
const SearchWrapper = require('../../modules/wrappers/search/SearchWrapper');

window.addEventListener('load', async () => {

    try {
        let search = new SearchWrapper();
        await search.showResult();
    } catch (e) {
        console.log(e);
    }

});